"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zhTw = exports.ja = exports.es = exports.en = void 0;
var en_json_1 = require("./lib/en.json");
Object.defineProperty(exports, "en", { enumerable: true, get: function () { return __importDefault(en_json_1).default; } });
var es_json_1 = require("./lib/es.json");
Object.defineProperty(exports, "es", { enumerable: true, get: function () { return __importDefault(es_json_1).default; } });
var ja_json_1 = require("./lib/ja.json");
Object.defineProperty(exports, "ja", { enumerable: true, get: function () { return __importDefault(ja_json_1).default; } });
var zh_tw_json_1 = require("./lib/zh-tw.json");
Object.defineProperty(exports, "zhTw", { enumerable: true, get: function () { return __importDefault(zh_tw_json_1).default; } });
